export function buildOrderUpdates(orderedIds) {
    return orderedIds.map((id, index) => ({ id, order: index }))
}
